import "basscss/css/basscss.css";
import "reset-css";
import "@minervaproject/fds/css/forum-design-system.css";

import { AlertProvider } from "@minervaproject/fds";
import jwt from "jsonwebtoken";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { App } from "components/app";
import { Monitoring } from "components/monitoring";
import { MonitoringWrapper } from "components/monitoring/monitoring_wrapper";
import { RedirectToNotFound } from "components/shared/redirect_to_forum";
import { Settings } from "settings";
import { redirectToLogin } from "utils/classroom";
import { getAuthToken } from "utils/cookie";

window.Settings = Settings;

const Flight = () => {
  const flightAuthToken = getAuthToken();
  const flightAuth = jwt.decode(flightAuthToken);

  useEffect(() => {
    const { exp } = (typeof flightAuth === "object" && flightAuth) || {};
    const jwtExpired = exp && exp < Math.round(Date.now() / 1000);
    if (!flightAuthToken || !exp || jwtExpired) {
      if (jwtExpired) {
        window.flightLogger?.warn("JWT expired. Redirecting to Forum to re-authenticate.");
      } else if (!flightAuthToken) {
        window.flightLogger?.warn("JWT not found. Redirecting to Forum to authenticate.");
      } else {
        window.flightLogger?.warn(
          "No expiry date on the JWT. Redirecting to Forum to authenticate.",
        );
      }
      redirectToLogin();
    }
  }, [flightAuthToken, flightAuth]);

  return (
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="classes/:classId">
            <Route path="observe" element={<App />} />
            <Route path="" element={<App />} />
          </Route>
          <Route path="monitoring" element={<Monitoring />} />
          <Route
            path="monitoring/classes/:classId"
            element={
              <AlertProvider>
                <MonitoringWrapper />{" "}
              </AlertProvider>
            }
          />
          <Route
            path="monitoring/classes/:classId/users/:userId"
            element={
              <AlertProvider>
                <MonitoringWrapper />
              </AlertProvider>
            }
          />
          <Route path="*" element={<RedirectToNotFound />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
};

ReactDOM.render(<Flight />, document.getElementById("root"));
